import {
  iconCommonProps, iconDefaultProps, iconPropTypes
} from '../propTypes';

const Explicit = ({ className, color }) => (
  <svg
    className={ className }
    { ...iconCommonProps }
    viewBox='0 0 5 7'
  >
    <path
      d='M.41 7V0h4.43v1.25H1.76v1.57h2.8v1.2h-2.8v1.73h3.08V7H.41z'
      fill={ color }
    />
  </svg>
);

Explicit.propTypes = { ...iconPropTypes };

Explicit.defaultProps = { ...iconDefaultProps };

export default Explicit;